module.exports = __webpack_public_path__ + "static/media/package_design_brand_plain.4c448c35.svg";